import { Upload, Gauge, Flag } from "lucide-react";
import { SectionEyebrow } from "../landing/SectionEyebrow";

const STEPS = [
  { icon: Upload, title: "Upload",
    body: "Member uploads payslip, bank or M-Pesa statements, or business records — or answers guided questions where records are thin." },
  { icon: Gauge, title: "Assess",
    body: "Clinq's Capital Readiness Score and DSCR engine run an instant, SACCO-calibrated repayment-capacity check — alongside, not instead of, existing guarantor and collateral checks." },
  { icon: Flag, title: "Outcome",
    body: "The member receives one of two clear results — a qualified indicative offer, or a readiness report with a clear path forward." },
];

export const SaccoHowItWorks = () => (
  <section className="bg-[#F5F7F7]" data-testid="sacco-how-it-works">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-24">
      <SectionEyebrow testid="sacco-how-eyebrow">The Campaign</SectionEyebrow>
      <h2 className="mt-6 text-2xl font-extrabold text-[#0B2A28] sm:text-3xl" data-testid="sacco-how-heading">
        Find Out If Your Member Qualifies — Today
      </h2>
      <div className="relative mt-12 grid gap-6 md:grid-cols-3">
        <div className="pointer-events-none absolute left-[16%] right-[16%] top-8 hidden border-t-2 border-dashed border-[#0A8B85]/30 md:block" />
        {STEPS.map(({ icon: Icon, title, body }, i) => (
          <div key={title} className="relative rounded-2xl bg-white p-7 shadow-sm ring-1 ring-neutral-200" data-testid={`sacco-step-${i + 1}`}>
            <div className="flex items-center gap-3">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#0B2A28] text-white ring-4 ring-white">
                <Icon size={24} />
              </span>
              <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#0A8B85]">Step {i + 1}</span>
            </div>
            <p className="mt-5 text-base font-bold text-[#0B2A28] md:text-lg">{title}</p>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600">{body}</p>
          </div>
        ))}
      </div>
      <p className="mt-10 border-l-4 border-[#E3B84C] pl-5 text-base font-semibold text-[#0B2A28] md:text-lg" data-testid="sacco-how-tagline">
        Every member gets a clear answer in minutes — not a multi-week application with no visibility.
      </p>
    </div>
  </section>
);
